import {Stack} from '@primer/react'
import {useGetPendingCommentsFromStoreWithoutDiffEntries} from '../../../../hooks/use-generate-pending-comments'
import {usePendingReviews} from '../../../../stores/layout-selectors'
import {PendingCommentPreview} from '../../../comments/PendingCommentPreview'
import {use} from 'react'
import {ContextualCommentControlsContext} from '../../../comments/CommentsContext'

export function LegacyPendingCommentsPreview() {
  const contextualCommentControls = use(ContextualCommentControlsContext)
  const pendingReview = usePendingReviews()
  const commentsList = useGetPendingCommentsFromStoreWithoutDiffEntries(pendingReview.pendingReviewIDs)

  return (
    <Stack direction="vertical" spacing="normal" paddingBlock="condensed">
      {commentsList?.map(pendingComment => (
        <PendingCommentPreview
          key={pendingComment.commentID}
          pendingComment={pendingComment}
          contextualCommentControls={contextualCommentControls}
        />
      ))}
    </Stack>
  )
}
